import styled from 'styled-components';
import { Config } from '../types';
import './ContentEditable.css';

import { ContentEditable } from '@lexical/react/LexicalContentEditable';

type Props = {
  className?: string;
  placeholderClassName?: string;
  placeholder: string;
  widgetConfig?: Config;
  previewScrollbar?: boolean;
};

const StyledContentEditable = styled(ContentEditable)<{
  editableContentHeight?: number;
  previewScrollbar?: boolean;
}>`
  overflow: hidden;
  overflow-y: auto;
  height: ${props => props.editableContentHeight}px;
  scrollbar-width: ${props => (props.previewScrollbar ? 'thin' : 'auto')};

  &::-webkit-scrollbar {
    width: ${props => (props.previewScrollbar ? '10px' : '0')};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props =>
      props.previewScrollbar ? 'rgba(0, 0, 0, 0.35)' : 'transparent'};
    border-radius: 8px;
  }
`;

export default function LexicalContentEditable({
  className,
  placeholder,
  placeholderClassName,
  widgetConfig,
  previewScrollbar = false,
}: Props): JSX.Element {
  return (
    <StyledContentEditable
      data-test-id="rich-text-editor-content-editable"
      className={`ContentEditable__root ${className ?? ''}`}
      aria-placeholder={placeholder}
      placeholder={
        <div className={placeholderClassName ?? 'ContentEditable__placeholder'}>
          {placeholder}
        </div>
      }
      editableContentHeight={Number(widgetConfig?.height)}
      previewScrollbar={previewScrollbar}
    />
  );
}
